import(/* webpackMode: "eager", webpackExports: ["TaskTabs"] */ "/app/src/app/(training)/task/[name]/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateTime"] */ "/app/src/components/date.tsx");
